import axios from "axios";
import request from "@/utils/microSeviceFormatRequest";
import onlyNasFileUploadUseRequest from "@/utils/onlyNasFileUploadUseRequest";

export function getTutorLessonDurationTest(start, end) {
  return request({
    url: "/api/ClassTable/GetTutorLessonDurationTest",
    data: {
      startTime: start.toDateString(),
      endTime: end.toDateString(),
    },
    method: "post",
  });
}

export function getTutorLessonDurationCancle(start, end) {
  return request({
    url: "/api/ClassTable/getTutorLessonDurationCancle",
    data: {
      startTime: start.toDateString(),
      endTime: end.toDateString(),
    },
    method: "post",
  });
}

export function getRemainingCancelCountOfThisWeek() {
  return request({
    url: "/api/ClassTable/GetRemainingCancelCountOfThisWeek",
    method: "post",
  });
}

export function autonomousCancellation(formData) {
  return onlyNasFileUploadUseRequest({
    url: "/api/ClassTable/AutonomousCancellation",
    method: "post",
    data: formData,
    timeout: 5 * 60 * 1000,
  });
}

export function getCancelRightsInfo() {
  return request({
    url: "/api/ClassTable/GetCancelRightsInfo",
    method: "post",
  });
}

export function getTutorSelfCancelTest() {
  return request({
    url: "/api/ClassTable/GetTutorSelfCancelTest",
    method: "post",
  });
}

export function getTutorRealTimeClassInfo() {
  return request({
    url: "/api/ClassTable/GetTutorRealTimeClassInfo",
    method: "post",
  });
}

export function getTutorRealTimeClassByWeek() {
  return request({
    url: "/api/ClassTable/GetTutorRealTimeClassByWeek",
    method: "post",
  });
}

/* ---------- Class Detail ---------- */

export function getClassDetails(clid) {
  return request({
    url: "/api/ClassTable/GetClassDetails?clid=" + clid,
    method: "post",
    timeout: 1 * 60 * 1000,
  });
}

export async function getTeachingMaterials(UCID, isTest) {
  return request({
    url: "/api/ClassTable/GetTeachingMaterials",
    data: { UCID, isTest },
    method: "post",
  });
}

export function setTeachingMaterials(data) {
  return request({
    url: "/api/ClassTable/SetTeachingMaterials",
    data,
    method: "post",
  });
}

export function getMeterialRemarkDetail(data) {
  return request({
    url: "/api/ClassTable/GetMaterialRemarkDetail",
    data,
    method: "post",
  });
}

export function getIsDivertUser(uid) {
  return request({
    url: "/api/ClassTable/GetIsDivertUser?uid=" + uid,
    method: "post",
  });
}

export function getMaterialsByDivertUser(clid, uid) {
  return request({
    url: `/api/ClassTable/GetMaterialsByDivertUser?clid=${clid}&uid=${uid}`,
    method: "post",
  });
}

export function setMaterialsByDivertUser(clid, uid, sid, catId) {
  return request({
    url: `/api/ClassTable/SetMaterialsByDivertUser?clid=${clid}&uid=${uid}&sid=${sid}&catId=${catId}`,
    method: "post",
  });
}

export function EndClass(param) {
  return request({
    url: "/api/ClassTable/SumbitClassMomoLater",
    method: "post",
    data: param,
    timeout: 5 * 60 * 1000,
  });
}

export function JoinClassIn(clid) {
  return request({
    url: "/api/ClassTable/JoinClassIn?clid=" + clid,
    method: "post",
  });
}

export function JoinAclassroom(clid) {
  return request({
    url: "/api/ClassTable/JoinAclassroom?clid=" + clid,
    method: "post",
  });
}

/** 老师 Token（Vue2 GetTeacherToken）— 供课堂 / TutorClient GetTeachUserData */
export function GetTeacherToken() {
  return request({
    url: "/api/ClassTable/GetTeacherToken",
    method: "post",
    timeout: 60 * 1000,
  });
}

/** Vue2 classToolBtn JoinAclassroom — primary entry for AClassroom */
export function JoinNetWorkAclassroom(clid, isMac = 0) {
  return request({
    url: "/api/ClassTable/JoinNetWorkAclassroom?clid=" + clid + "&isMac=" + isMac,
    method: "post",
    timeout: 60 * 1000,
  });
}

/** 声网教室内：是否有备课信息 */
export function GetTutorLessonPlanState(clid) {
  return request({
    url: `/api/ClassTable/GetTutorLessonPlanState?clid=${clid}`,
    method: "post",
  });
}

/** 声网教室：按教材名搜索 */
export function SearchCourseInfoByName(subjectName, currentPage, pageSize) {
  return request({
    url:
      "/api/NetlessRTCRoom/SearchCourseInfoByName?subjectName=" +
      encodeURIComponent(subjectName) +
      "&currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    method: "post",
    baseURL: import.meta.env.VITE_API_HOST_ACCOREAPI,
  });
}

/** 声网教室：换课 */
export function ChangeSidByLessonInfo(param) {
  return request({
    url: "/api/NetlessRTCRoom/ChangeSidByLessonInfo",
    method: "post",
    data: param,
    baseURL: import.meta.env.VITE_API_HOST_ACCOREAPI,
  });
}

export function getTrialClassSMSNoticeStatus(clid) {
  return request({
    url: "/api/ClassTable/GetTrialClassSMSNoticeStatus?clid=" + clid,
    method: "post",
  });
}

export function sendTrialClassSMSNotice(clid) {
  return request({
    url: "/api/ClassTable/SendTrialClassSMSNotice?clid=" + clid,
    method: "post",
  });
}

export function getLessonPlanInfo(clid) {
  return request({
    url: "/api/ClassTable/GetLessonPlanInfo?clid=" + clid,
    method: "post",
  });
}

export function saveLessonPlanInfo(param) {
  return request({
    url: "/api/ClassTable/SaveLessonPlanInfo",
    method: "post",
    data: param,
  });
}

export function CSAssistance(param) {
  return request({
    url: "/api/ClassTable/CSAssistance",
    method: "post",
    data: param,
  });
}

export function GetClassProblem() {
  return request({
    url: "/api/ClassTable/GetClassProblem",
    method: "post",
  });
}

export function GetTutorAccount() {
  return request({
    url: "/api/account/GetTutorAccount",
    method: "post",
  });
}

export function getTimestamp() {
  return request({
    url: "/api/System/GetTimestamp",
    method: "get",
  });
}

/* ---------- Class Remarks ---------- */

export function leaveClassRemark(param) {
  return request({
    url: "/api/ClassTable/ClassMomoEdit",
    method: "post",
    data: param,
    timeout: 5 * 60 * 1000,
  });
}

export function vipClassRemark(param) {
  return request({
    url: "/api/ClassTable/VipClassRemark",
    method: "post",
    data: param,
    timeout: 5 * 60 * 1000,
  });
}

export function knowledgePointsClassRemark(param) {
  return request({
    url: "/api/ClassTable/KnowledgePointsClassRemark",
    method: "post",
    data: param,
    timeout: 5 * 60 * 1000,
  });
}

export function GetCoursewareKnowledgePointBySId(sid) {
  return request({
    url: "/api/ClassTable/GetCoursewareKnowledgePointBySId?sId=" + sid,
    method: "post",
  });
}

export function GetUserUserReportByID(usid) {
  return request({
    url: "/api/ClassTable/GetUserUserReportByID?usid=" + usid,
    method: "post",
  });
}

export function GetWonderfulPictures(clid) {
  return request({
    url: `/api/ClassTable/GetWonderfulPictures?clid=${clid}`,
    method: "post",
  });
}

export function GetCourseEvaluationInfo(clid) {
  return request({
    url: "/api/ClassTable/GetCourseEvaluationInfo?clid=" + clid,
    method: "post",
  });
}

/* ---------- CS Assistance / Materials ---------- */

export function getClassProblemIncludeChildren(classTool) {
  return request({
    url: `/api/ClassTable/GetClassProblemIncludeChildren?classTool=${classTool || 0}`,
    method: "post",
  });
}

export function GetCSPloblemDetails(clid, type) {
  return request({
    url: `/api/ClassTable/GetCSPloblemDetails?clid=${clid}&type=${type}`,
    method: "post",
  });
}

export function ReportMistakeMaterial(data) {
  return request({
    url: "/api/ClassTable/ReportMistakeMaterial",
    data,
    method: "post",
  });
}

export function saveMaterialResonlist(param) {
  return request({
    url: "/api/ClassTable/SaveMaterialResonlist",
    method: "post",
    data: param,
  });
}

export function SumbitTheSameMaterials(clid, tuid, uid, classTime) {
  return request({
    url: `/api/ClassTable/SumbitTheSameMaterials?clid=${clid}&tuid=${tuid}&uid=${uid}&classTime=${classTime}`,
    method: "post",
  });
}

export function UploadAbsentPic(param) {
  return onlyNasFileUploadUseRequest({
    url: "/api/ClassTable/UploadAbsentPic",
    method: "post",
    data: param,
    timeout: 5 * 60 * 1000,
  });
}

export function AllowUploadAbsentPic(clid) {
  return request({
    url: "/api/ClassTable/AllowUploadAbsentPic?clid=" + clid,
    method: "post",
  });
}

export function GetTencentRoomID(clid) {
  return request({
    url: `/api/ClassTable/GetTencentRoomID?clid=${clid}`,
    method: "post",
  });
}

export function GetLiveLessonRoomLink(clid) {
  return request({
    url: "/api/ClassTable/GetLiveLessonRoomLink?clid=" + clid,
    method: "post",
  });
}

export function getCurrentStudentAppraisalItemSuggestionList(uid) {
  return request({
    url: "/api/ClassTable/GetCurrentStudentAppraisalItemSuggestionList?uid=" + uid,
    method: "post",
  });
}

export function insertSuggestClickLog(clid, suggestId) {
  return request({
    url: "/api/ClassTable/InsertSuggestClickLog?clid=" + clid + "&suggestId=" + suggestId,
    method: "post",
  });
}

export function InsertStudentAppraisalPopupLog(clid, staySeconds, isRead) {
  return request({
    url:
      "/api/ClassTable/InsertStudentAppraisalPopupLog?clid=" +
      clid +
      "&staySeconds=" +
      staySeconds +
      "&isRead=" +
      isRead,
    method: "post",
  });
}

/** 行为埋点（Vue2 RecordUserBehavior）— 独立域名 + X-Secret，不走主站签名 */
export function RecordUserBehavior(data) {
  return axios.post(
    `${import.meta.env.VITE_API_HOST_BEHAVIOR || ""}/api/TeacherSystem/TutorWeb/AddCustomData`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Secret": "703E2AEF23C7EE2F90077AF25033CDC698F56D8233169094",
      },
      timeout: 10000,
    }
  );
}
